import styled, { useTheme } from 'styled-components'
import { LinkButton } from '@/components/common/buttons'
import { Typo, TypoVariant } from '@/components/common/typography'
import ROUTES from '@/constants/legacy/constRoutes'
import { QueryStringKeyEnum } from '@/constants/query-string-key.enum'
import { useCustomRouter } from '@/containers/hooks'
import { AdPetType } from '@/graphql/generated/schemas'

const welcomeDealTabs = [
  {
    name: '고양이',
    petType: AdPetType.Cat,
  },
  {
    name: '강아지',
    petType: AdPetType.Dog,
  },
]

type Event100WonDealProps = {
  petType: AdPetType
}

export default function Event100WonDealTab({ petType }: Event100WonDealProps) {
  const { color } = useTheme()
  const { asPath } = useCustomRouter()
  return (
    <StyledEvent100WonDealContainer className="welcome-deal">
      {welcomeDealTabs.map(({ name, petType: _petType }) => {
        const isActive = petType === _petType
        const fontColor = isActive ? color.grayWhite : color.gray900
        return (
          <LinkButton
            className={`welcome-deal__button ${isActive ? 'welcome-deal__button--active' : ''}`}
            key={name}
            url={{
              pathname: ROUTES.EVENTS_100_DEAL,
              query: {
                pagePetType: _petType,
                [QueryStringKeyEnum.PrevPath]: `${asPath.split('?')[0]}?pagePetType=${petType}`,
              },
            }}
            routeType="replace"
          >
            <Typo variant={TypoVariant.Body1Bold} color={fontColor}>
              {name}
            </Typo>
          </LinkButton>
        )
      })}
    </StyledEvent100WonDealContainer>
  )
}

const StyledEvent100WonDealContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  .welcome-deal {
    &__button {
      height: 50px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${({
        theme: {
          color: { grayWhite },
        },
      }) => grayWhite};
      &--active {
        background-color: ${({
          theme: {
            color: { blue500 },
          },
        }) => blue500};
      }
    }
  }
`
